import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'
import CircularProgress from '@material-ui/core/CircularProgress'
import React from "react";

export const CircularProgressStyled = styled(props => <CircularProgress {...props}/>)`

  width:${props => props.width ? props.width : '78px'} !important;
  height: ${props => props.height ? props.height : '78px'} !important;

`

export const MTCircularPercentContainerStyled = styled.div`
  line-height: 18px;
  margin-left: ${props => props.left ? "-20px" : '0'};
  /* Título (Match, Profile, Skills): etiqueta de 14/600, independiente del tamaño del valor */
  p {
    text-align: center;
    font-weight: 600;
    line-height: 20px !important;
    font-size: 14px !important;
    margin-bottom: 8px;
    color: ${tokens.color.text.secondary};
  }
`

export const MTCircularPercentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
  
  /* El valor va centrado sobre el círculo */
  .value {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: ${props => props.fontSize ? props.fontSize : '14px'} !important;
    font-weight: ${props => props.fontWeight || 600};
    line-height: 18px;
    color: ${tokens.color.text.primary};
  }

  .circular-progress {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* Pista neutra suave y arco con el extremo redondeado */
    .top {
      color: ${tokens.color.border.subtle};
    }

    .bottom {
      position: absolute;
      left: 0;
      animation-duration: 0.5s;

      circle {
        stroke-linecap: round;
      }
    }

    .valid {
      color: ${tokens.color.success.main};
    }

    .invalid {
      color: ${tokens.color.error.main};
    }
    
    .theme {
      color: ${props => props.theme.primary};
    }
  }
`
